export const DEFAULT_HELICAL_LOG = {
  pileNo: '',
  startTime: null,
  completionTime: null,
  pileShaft: '',
  pileLength: '',
  leadHelices: '',
  measurements: null,
  requiredTorque: '',
  finalTorque: '',
  anticipatedDepth: '',
  minimumDepth: '',
  finalDepth: '',
  aboveGround: '',
  criteriaMet: false,
  deviationNS: '',
  deviationEW: '',
  deviationV: '',
  plannedInclination: '',
  measuredInclination: '',
  comments: ''
};

export const ROWS_PER_PAGE = 35;
